import { storageKeyForBanner } from 'reactApp/appHelpers/featuresHelpers/features/vigboPrintFakedoor';
import { getBannerDataFromStorage, markBannerCompleted } from 'reactApp/storage';

// Кэшируем походы к localStorage, так как тултип в тулбаре может часто вызывать проверку
let isCompleted: boolean | undefined;

export const isFakedoorCompleted = () => {
    if (isCompleted !== undefined) {
        return isCompleted;
    }

    isCompleted = getBannerDataFromStorage(storageKeyForBanner).state;
    return isCompleted;
};

export const markFakedoorCompleted = (markInLocalStorage = true) => {
    if (markInLocalStorage) {
        markBannerCompleted(storageKeyForBanner);
    }
    isCompleted = true;
};
